import React from "react";
import "./New.scss";
import Comingsoon from "../../media/Web_Ruko Terra.webp";
import Soon from "../../media/Mobile_Terra.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6281574115424&text=Halo+Radi%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Ruko%20Terra)%20https://www.grandwisata-marketing.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="n1" className="container-soon">
      <div className="louise">
        <h1>New Launching Grand Wisata</h1>
        <h2> Terra Business Loft at Prospera Hub</h2>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
